import errorParser from '@/utils/error-parser'
import RestResourceService from "@/services/RestResourcesService";

function initialState() {
    return {
        instances: [],
        status: null,
    }
}

export default {
    state: initialState(),
    getters: {
        STATUS: state => state.status,
        INSTANCES: state => state.instances,
    },
    mutations: {
        SET_STATUS(state, payload) {
            state.status = payload;
        },
        SET_INSTANCES(state, payload) {
            state.instances = payload;
        },
        RESET(state) {
            const s = initialState();
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        }
    },
    actions: {
        GET_STATUS: ({commit, dispatch}, payload) => {
            return RestResourceService.getResources(payload.url)
                .then((response) => {
                    commit('SET_STATUS', response.data);
                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: false,
                    });
                    throw new Error(error);
                })
        },
        GET_INSTANCES: ({commit, dispatch}, payload) => {
            return RestResourceService.getResources(payload.url)
                .then((response) => {
                    commit('SET_INSTANCES', response.data);
                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: false,
                    });
                    throw new Error(error);
                })
        },
        POST_REBUILD: ({commit, dispatch}, payload) => {
            return RestResourceService.postResources(payload.url, {})
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: false,
                    });
                    throw new Error(error);
                })
        },
    }
}
